import { QuoteEligibilityParameters } from '@domgen/dgx-fe-basket';

export interface SelectedQuotesIneligibilityModalData {
  quoteEligibilityParameters: QuoteEligibilityParameters;
}
